// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 744 ? "actioncable" : chunkId) + "-" + {"344":"94a463049d9c5cb1282c","481":"c70c8614599dcc79079a","605":"6323dbf6528cf194df82","744":"8b387cb23a4d51b4a473"}[chunkId] + ".chunk.js";
};